import Vue from 'vue'
import Antd from 'ant-design-vue';

import App from './App.vue'
import Button from 'ant-design-vue/lib/button'
import 'ant-design-vue/dist/antd.css'
import  './assets/css/index.css'
import VueLazyload from 'vue-lazyload'
import VideoPlayer from 'vue-video-player'
import animated from 'animate.css' 
// import AudioPlayer from '@liripeng/vue-audio-player'
// import '@liripeng/vue-audio-player/lib/vue-audio-player.css'

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.use(animated)
// Vue.use(AudioPlayer)

Vue.use(VueLazyload, {
  preLoad: 0.7,
  error: 'http://www.artgogo.com/new_pcwork/img/default_avatar128.jpg',
  loading: 'http://www.artgogo.com/online-exhibition/img/load.jpg',
  attempt: 1
})

Vue.component(Button.name, Button);
Vue.use(Antd);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#apps')
